import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.scss";
import { useLoginUserMutation } from "../../redux-toolkit/services/authService";
import { toast } from "react-toastify";
import { alertMessage } from "../../utils/AlertService";
import { setAuthState } from "../../redux-toolkit/slices/authSlice";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import ForgotResetPassword from "./ForgotResetPassword";
import { Typography } from "antd";
import Header from "../../components/Header/Header";
import { PAGE_TITLE } from "../constant/reportType";
import ProsperoLogo from "../../assets/logo/prospero_logo.png";

type Props = {};

const { Link: AntdLink } = Typography;

const Login = (props: Props) => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotPasswordShow, setForgotPasswordShow] = useState(false);
  const localUserObj = JSON.parse(localStorage.getItem("localUser") || "{}");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Mutation
  const [loginUser, loginResponse] = useLoginUserMutation();

  const handleForgotPasswordShow = () => setForgotPasswordShow(true);

  // useEffect(() => {
  //   if(localUserObj?.token) {

  //   }
  // })

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log(e)
    if (!email || !password) {
      toast.error("Please enter your login credentials");
    } else {
      await loginUser({
        username: email,
        password: password,
        // userRole: "admin",//values.userrole,
      });
    }
  };

  useEffect(() => {
    if (loginResponse.isSuccess) {
      alertMessage("Login successful", "success");
      dispatch(setAuthState(loginResponse.data));

      const localUserObj = {
        token: loginResponse.data.jwtToken,
        userType: loginResponse.data.userRoleName,
        id: loginResponse.data.id,
        username: loginResponse.data.username,
        packageId: loginResponse.data.packageId,
        defaultCurrency: loginResponse.data.defaultCurrency,
        createdDate: loginResponse.data.createdDate,
        packageType: loginResponse.data.packageType,
      };
      console.log(localUserObj, "localUserObj");

      localStorage.setItem("localUser", JSON.stringify(localUserObj));
      localStorage.setItem("name", JSON.stringify(loginResponse.data.username));

      // Navigate to a different page after login
      navigate("/dashboard");

    } else if (loginResponse.isError) {
      let response: any = loginResponse?.error;
      console.log(response, "response");

      alertMessage(response.error.data.serviceErrors[0].msg ?
        response?.error?.data?.serviceErrors[0].msg : "Invalid email or password", "error");
    }
  }, [loginResponse.isSuccess]);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="container" style={{ paddingRight: "5rem", paddingLeft: "5rem" }}>
          <div className="row cdvfdfd">
            <div className="col-lg-6 col-md-12 login-box">
              <div className="row justify-content-center">
                <div className="col-lg-12 col-md-6 log-det">
                  <div className="login-logo-container">
                    <img
                      src={ProsperoLogo}
                      alt="Prospero Logo"
                      className="login-logo"
                    />
                  </div>
                  <h2 className="text-xl fw-bold mb-2 text-center">Login</h2>
                  <form onSubmit={handleSubmit}>
                    {loginResponse.isSuccess ?
                      <Loading /> : ("")}
                    <div className="text-box-cont">
                      <input
                        type="text"
                        className="form-control mb-1"
                        placeholder="Username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                      <input
                        type="password"
                        className="form-control mt-4"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} />

                      <div>
                        <button
                          className="btn btn-success text-white fw-bold mt-3"
                          type="submit"
                        >
                          LOG IN
                        </button>
                      </div>
                      <div className="row">
                        <p className="forget-p">
                          Don't have an account?{" "}
                          <Link className="text-accent fw-bold" to="/signup">
                            Sign Up Now
                          </Link>
                        </p>
                        <p className=" text-center mx-1">
                          <AntdLink onClick={handleForgotPasswordShow} className=" text-accent fw-bold">
                            Forgot password?
                          </AntdLink>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {forgotPasswordShow && (
          <ForgotResetPassword
            forgotResetShow={forgotPasswordShow}
            setForgotResetShow={setForgotPasswordShow}
            title={PAGE_TITLE.FORGOT_PASSWORD} />
        )}
      </div>
    </>
  );
}

export default Login;
